export const VERBIAGE_CONSTANTS = {
	SIGN_IN_BROKER: "Sign in as a broker to gain access.",
	SWITCH_ORG: "Are you sure you want to switch organization?",
	SURE_EXIT: "Are you sure you want to exit?",
	CLOSING_DATE_AFTER_PURCHASE_CLOSE_DATE:
		"The Closing Date entered is after the Purchase Contract Close Date. Is this correct?",
	CLOSING_DATE_LESS_THAN_10_BUSINESS_DAYS:
		"The Closing Date and/or the Purchase Contract Close Date entered is < 10 business days from today’s date. Is this correct?",
	CREDIT_REISSUE_DISCLAIMER:
		"Before you continue, make sure that you've reissued credit for all borrower pairs",
	RESET_ORGANIZATION_PASSWORD:
		"Resetting passwords for all users within this organization. Would you like to proceed?",
	QUICK_PRICER_PUBLIC_DISCLAIMER:
		"Pricing is updated daily between 11:00 AM EST and 11:30 AM EST and may change at any time without prior notice. Quotes provided through this tool are estimates only. Definitive pricing is established solely through a completed and accepted Lock Request. Please log in to ensure accurate pricing.",
};
